import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './lib/AuthContext';
import { ThemeProvider } from './lib/ThemeProvider';
import { TooltipProvider } from './components/ui/tooltip';
import Login from './components/Auth/Login';
import ProtectedRoute from './components/Auth/ProtectedRoute';
import AdminProtectedRoute from './components/Auth/AdminProtectedRoute';
import Dashboard from './components/Dashboard/Dashboard';
import AdminDashboard from './components/Admin/AdminDashboard';
import UserManagement from './components/Admin/UserManagement';
import PeerReviewQuestions from './components/Admin/PeerReviewQuestions';
import EngagementPulseQuestions from './components/Admin/EngagementPulseQuestions';
import EngagementPulseResponses from './components/Admin/EngagementPulseResponses';
import ReviewManagement from './components/Admin/ReviewManagement';
import ReviewDetails from './components/Admin/ReviewDetails';
import PulseResponseDetails from './components/Admin/PulseResponseDetails';
import PeerReview from './components/Review/PeerReview';
import PeerReviewForm from './components/Review/PeerReviewForm';
import EngagementPulseCheck from './components/Review/EngagementPulseCheck';
import './App.css';

function App() {
  return (
    <ThemeProvider defaultTheme="light">
      <AuthProvider>
        <TooltipProvider>
          <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            
            {/* Protected Dashboard Route */}
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            
            {/* Admin Routes */}
            {/* Managers are allowed into the dashboard; it scopes itself to their direct reports */}
            <Route path="/admin" element={
              <AdminProtectedRoute allowManagers>
                <AdminDashboard />
              </AdminProtectedRoute>
            } />
            <Route path="/admin/users" element={
              <AdminProtectedRoute>
                <UserManagement />
              </AdminProtectedRoute>
            } />
            <Route path="/admin/questions" element={
              <AdminProtectedRoute>
                <PeerReviewQuestions />
              </AdminProtectedRoute>
            } />
            <Route path="/admin/pulse-questions" element={
              <AdminProtectedRoute>
                <EngagementPulseQuestions />
              </AdminProtectedRoute>
            } />
            <Route path="/admin/pulse-responses" element={
              <AdminProtectedRoute>
                <EngagementPulseResponses />
              </AdminProtectedRoute>
            } />
            <Route path="/team/pulse-responses" element={
              <ProtectedRoute>
                <EngagementPulseResponses mode="manager" />
              </ProtectedRoute>
            } />
            <Route path="/admin/reviews" element={
              <ProtectedRoute>
                <ReviewManagement />
              </ProtectedRoute>
            } />
            <Route path="/admin/reviews/:userId" element={
              <ProtectedRoute>
                <ReviewDetails />
              </ProtectedRoute>
            } />
            <Route path="/admin/pulse-response/:submissionId" element={
              <ProtectedRoute>
                <PulseResponseDetails />
              </ProtectedRoute>
            } />
            
            {/* Review Routes */}
            <Route path="/review/:userId" element={
              <ProtectedRoute>
                <PeerReview />
              </ProtectedRoute>
            } />
            <Route path="/review/:userId/form" element={
              <ProtectedRoute>
                <PeerReviewForm />
              </ProtectedRoute>
            } />
            
            {/* Engagement Pulse Check Route */}
            <Route path="/pulse-check" element={
              <ProtectedRoute>
                <EngagementPulseCheck />
              </ProtectedRoute>
            } />
            
            {/* Default redirect */}
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            
            {/* Catch all route */}
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
          </Router>
        </TooltipProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
